var ServiceEntriesViewState;
(function (ServiceEntriesViewState) {
    ServiceEntriesViewState["MAP"] = "map";
    ServiceEntriesViewState["TABLE"] = "table";
})(ServiceEntriesViewState || (ServiceEntriesViewState = {}));
export default ServiceEntriesViewState;
